import React from 'react';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import { withRouter } from 'react-router-dom';
// Queries
import CURRENT_USER from '../../GraphQl/Queries/CURRENT_USER';
// Locals
import Controller from './Controller';

const Loader = (props) => {
  const { children } = props;
  // If currentUser is not provided, it will be fetched from the query
  return (
    <Controller {...props} currentUser={props.currentUser}>
      {children}
    </Controller>
  );
};

export default compose(
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  })
)(withRouter(Loader));
